import React, { useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import care1 from "../../static/media/Home/CarePillars/care1.webp";
import care2 from "../../static/media/Home/CarePillars/care2.webp";
import care3 from "../../static/media/Home/CarePillars/care3.webp";

const PRIMARY = "#06BBC7";

const pillars = [
  {
    image: care1,
    text: "Evaluación personalizada",
  },
  {
    image: care2,
    text: "Acompañamiento profesional",
  },
  {
    image: care3,
    text: "Resultados visibles y seguros",
  },
];

const CarePillars = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % pillars.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      component="section"
      sx={{
        bgcolor: PRIMARY,
        py: { xs: 2, md: 3.5 },
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: { xs: "none", sm: "grid" },
            gridTemplateColumns: "repeat(3, 1fr)",
            alignItems: "center",
            gap: { sm: 2, md: 4 },
            maxWidth: 1120,
            mx: "auto",
          }}
        >
          {pillars.map((item) => (
            <Box
              key={item.text}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: { sm: 1.5, md: 2 },
                minWidth: 0,
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={item.text}
                loading="lazy"
                sx={{
                  width: { sm: 58, md: 76 },
                  height: { sm: 58, md: 76 },
                  objectFit: "contain",
                  flexShrink: 0,
                  display: "block",
                }}
              />

              <Typography
                sx={{
                  color: "#ffffff",
                  fontSize: { sm: "0.96rem", md: "1.08rem" },
                  fontWeight: 700,
                  lineHeight: 1.18,
                  letterSpacing: "-0.01em",
                  maxWidth: { sm: 190, md: 230 },
                }}
              >
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            alignItems: "center",
            justifyContent: "center",
            minHeight: 78,
          }}
        >
          <Box
            key={pillars[activeIndex].text}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1.6,
              width: "100%",
              animation: "fadePillar 0.45s ease",
              "@keyframes fadePillar": {
                "0%": {
                  opacity: 0,
                  transform: "translateY(8px)",
                },
                "100%": {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
          >
            <Box
              component="img"
              src={pillars[activeIndex].image}
              alt={pillars[activeIndex].text}
              loading="lazy"
              sx={{
                width: 64,
                height: 64,
                objectFit: "contain",
                flexShrink: 0,
                display: "block",
              }}
            />

            <Typography
              sx={{
                color: "#ffffff",
                fontSize: "1rem",
                fontWeight: 700,
                lineHeight: 1.18,
                letterSpacing: "-0.01em",
                maxWidth: 220,
              }}
            >
              {pillars[activeIndex].text}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CarePillars;